import React, { useState, useEffect } from 'react';
import apiClient from '../../utils/api';
import './GeneralAudioManager.css';

function OfflineAudioManager() {
  const [audioFiles, setAudioFiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    loadOfflineAudio();
  }, []);

  const loadOfflineAudio = async () => {
    try {
      setLoading(true);
      const data = await apiClient.getOfflineAudio();
      setAudioFiles(data.files || []);
    } catch (error) {
      console.error('Error loading offline audio:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (audioFiles.length >= 12) {
      alert('Maximal 12 Offline-Audios erlaubt!');
      return;
    }

    try {
      setUploading(true);
      await apiClient.uploadOfflineAudio(file);
      await loadOfflineAudio();
      e.target.value = '';
    } catch (error) {
      alert('Fehler beim Hochladen der Audio-Datei');
      console.error(error);
    } finally {
      setUploading(false);
    }
  };

  const handleDelete = async (filename) => {
    if (!window.confirm(`${filename} l\u00f6schen?`)) {
      return;
    }

    try {
      await apiClient.deleteOfflineAudio(filename);
      await loadOfflineAudio();
    } catch (error) {
      alert('Fehler beim L\u00f6schen');
      console.error(error);
    }
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div className="general-audio-manager" data-testid="offline-audio-manager">
      <div className="audio-header">
        <div className="audio-header-left">
          <h3>Offline-Audios (PWA)</h3>
          <p className="audio-subtitle">
            Diese Audios werden im Browser gecacht für Offline-Nutzung. Max. 12 Dateien.
          </p>
          <div className="audio-count">
            {audioFiles.length} / 12 Dateien
          </div>
        </div>
        <label className="btn-upload">
          {uploading ? 'Hochladen...' : '+ Audio hochladen'}
          <input
            type="file"
            accept="audio/*"
            onChange={handleUpload}
            disabled={uploading || audioFiles.length >= 12}
            style={{ display: 'none' }}
            data-testid="offline-audio-upload-input"
          />
        </label>
      </div>

      {audioFiles.length === 0 ? (
        <div className="empty-state">
          <p>🎵 Noch keine Offline-Audios vorhanden</p>
          <p className="empty-hint">
            Laden Sie bis zu 12 Audio-Dateien hoch, die offline verfügbar sein sollen
          </p>
        </div>
      ) : (
        <div className="audio-list">
          {audioFiles.map((file, index) => (
            <div key={file} className="audio-item" data-testid={`offline-audio-item-${index}`}>
              <div className="audio-item-info">
                <span className="audio-icon">🎵</span>
                <span className="audio-name">{file}</span>
              </div>
              <div className="audio-item-actions">
                <audio
                  controls
                  src={`${process.env.REACT_APP_BACKEND_URL}/api/audio/offline/${file}`}
                  className="audio-player"
                  preload="none"
                />
                <button
                  onClick={() => handleDelete(file)}
                  className="btn-delete-audio"
                  data-testid={`delete-offline-audio-${index}`}
                >
                  Löschen
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {audioFiles.length >= 12 && (
        <div className="max-warning">
          ⚠️ Maximale Anzahl erreicht. Löschen Sie eine Datei, um eine neue hochzuladen.
        </div>
      )}
    </div>
  );
}

export default OfflineAudioManager;
